module.exports = __webpack_public_path__ + "img/中国移动1.38f8ec77.png";